import { useEffect, useState } from 'react'
import { getDisabledDates } from '../modules/appointment'

const useDisableDates = () => {
  const [data, setData] = useState({ items: [] })
  const [loading, setLoading] = useState(false)

  const fetcher = async () => {
    setLoading(true)
    const disabledDate = await getDisabledDates()
    setData({ items: disabledDate })
    setLoading(false)
  }

  useEffect(() => { fetcher() }, [])

  return { items: data.items, loading }
}

export default useDisableDates
